import { Layout } from 'antd';
import * as React from 'react';
import { Link } from 'react-router-dom';

import Logo from '../assets/logo-with-slogan.png';
import { MainLayoutHeader } from '../components/MainLayoutHeader';

export interface PublicLayoutProps {
  children: React.ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <Layout>
      <MainLayoutHeader>
        <Link className="brand" to="/">
          <img src={Logo} alt="yousmile" />
        </Link>
      </MainLayoutHeader>
      <Layout.Content className="contentWrapper">{children}</Layout.Content>
    </Layout>
  );
}
